import React, { useEffect, useState, lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";
import CLIENT_USER_MANAGEMENT from "./Utils/constants";
import CustomBreadcrumb from "../../Components/CustomBreadcrumb";
import constants from "../../Utils/constants";
import "./Styles/UserMangement.scss";
import { useDispatch } from "react-redux";
import { activeMenuTab } from "../../Store/Actions/User";
import { UserManagementServices } from "./Services/UserManagementServices";

const ListClientUsers = lazy(() => import("../ListClientUsers"));

const ListMagicLinkUsers = lazy(() =>
  import("../MagicLink/ListMagicLinkUsers")
);

const MagicLinkIcon = ({ color = "#000" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="custom-svg"
  >
    <path
      d="M1.6 12.3176C1.73333 12.2795 1.86333 12.2478 1.99 12.2224C2.11667 12.197 2.25333 12.1843 2.4 12.1843H3.2V3.04145H2.4C2.17333 3.04145 1.98333 3.11447 1.83 3.2605C1.67667 3.40653 1.6 3.58748 1.6 3.80336V12.3176ZM2.4 16.7557C1.73333 16.7557 1.16667 16.5335 0.7 16.0891C0.233333 15.6446 0 15.1049 0 14.47V3.80336C0 3.16844 0.233333 2.62875 0.7 2.18431C1.16667 1.73986 1.73333 1.51764 2.4 1.51764H8V3.04145H4.8V12.1843H9.6V9.89859H11.2V13.7081H2.4C2.17333 13.7081 1.98333 13.7811 1.83 13.9272C1.67667 14.0732 1.6 14.2542 1.6 14.47C1.6 14.6859 1.67667 14.8668 1.83 15.0129C1.98333 15.1589 2.17333 15.2319 2.4 15.2319H12.8V9.13669H14.4V16.7557H2.4ZM11.6 9.13669C11.6 7.96844 12.0267 6.97796 12.88 6.16526C13.7333 5.35256 14.7733 4.94621 16 4.94621C14.7733 4.94621 13.7333 4.53986 12.88 3.72717C12.0267 2.91447 11.6 1.92399 11.6 0.755737C11.6 1.92399 11.1733 2.91447 10.32 3.72717C9.46667 4.53986 8.42667 4.94621 7.2 4.94621C8.42667 4.94621 9.46667 5.35256 10.32 6.16526C11.1733 6.97796 11.6 7.96844 11.6 9.13669Z"
      fill={color}
    />
  </svg>
);

const UserManagement = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  // tabs for showing magic link user and normal user
  const tabs = [
    CLIENT_USER_MANAGEMENT.USER_MANAGEMENT_TAB.NORMAL_USER_TAB,
    CLIENT_USER_MANAGEMENT.USER_MANAGEMENT_TAB.MAGIC_LINK_USER_TAB,
  ];

  // states for showing count in header
  const [clientCount, setClientCount] = useState({
    total_client_users: null,
    total_magic_link_users: null,
    total_normal_users: null,
  });

  useEffect(() => {
    dispatch(activeMenuTab(constants.APPLICATION_ROUTE.CLIENT_USER.LIST.ROUTE));
    getUsersCount();
  }, []);

  // api for user count on header
  const getUsersCount = async () => {
    try {
      const res = await UserManagementServices.getUsersCount();
      const clientUserCountData = res.data.data;
      setClientCount({
        total_client_users: clientUserCountData.total_client_users,
        total_magic_link_users: clientUserCountData.total_magic_link_users,
        total_normal_users: clientUserCountData.total_normal_users,
      });
    } catch (error) {
      console.error("Error fetching user count:", error);
    }
  };

  // Set the default tab based on location.state
  const [activeTab, setActiveTab] = useState(
    location.state?.selectedTab ||
      CLIENT_USER_MANAGEMENT.USER_MANAGEMENT_TAB.NORMAL_USER_TAB
  );

  // function for handling tab change
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  // Breadcumbs - Title header
  const breadcrumbs = [
    {
      title: CLIENT_USER_MANAGEMENT.BREADCUMB.TITLE,
      link: null,
      is_active: false,
    },
  ];

  return (
    <aside className="main_content">
      <div className="m-3 mb-0 bg-white px-3 py-3 br_8 main_content_height">
        {/* Breadcrumb */}
        <div className="d-flex align-items-center flex-wrap title-section breadcrumb-mb-0 justify-content-between">
          <CustomBreadcrumb breadcrumbs={breadcrumbs} />
          <div className="d-flex gap-10">
            {/* Seat Limit */}
            <div className="tab-btn-2">
              <span
                className="material-icons-round icon-fs-20 mr-1"
                style={{ color: "#0461C2" }}
              >
                star
              </span>
              <span>
                Seat Limit: <span>{clientCount.total_client_users}</span>
              </span>
            </div>

            {/* Normal User */}
            <div className="tab-btn-2">
              <span
                className="material-icons-outlined icon-fs-20 mr-2"
                style={{ color: "#0461C2" }}
              >
                group
              </span>
              <span className="fs-14">
                Normal User:{" "}
                <span className="ml-1">{clientCount.total_normal_users}</span>
              </span>
            </div>

            {/* Magic Link User */}
            <div className="tab-btn-2">
              <span
                className="material-symbols-outlined icon-fs-20 mr-1"
                style={{ color: "#0461C2" }}
              >
                <MagicLinkIcon color="#0461C2" />
              </span>
              <span className="fs-14">
                Magic Link User:{" "}
                <span className="ml-1">
                  {clientCount.total_magic_link_users}
                </span>
              </span>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="div-1">
          <div className="d-flex g-15">
            {tabs.map((tab) => (
              <button
                key={tab}
                className={`tab-btn ${
                  activeTab === tab ? "active-tab" : "not-active-tab"
                }`}
                onClick={() => handleTabChange(tab)}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        {/* Tab Content with Lazy Loading */}
        <div className="magic-users-table">
          <div className="client-users-table-block colored-th-table-block custom-table-block custom-table-block-2 first-col-fixed-block last-col-fixed-block nowrap-table-block th-nowrap sort-table-block center-th-align">
            <Suspense fallback={<div className="mt-10">⏳ Loading...</div>}>
              {activeTab ===
              CLIENT_USER_MANAGEMENT.USER_MANAGEMENT_TAB.NORMAL_USER_TAB ? (
                <ListClientUsers />
              ) : (
                <ListMagicLinkUsers />
              )}
            </Suspense>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default UserManagement;
